/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

const prefix = 'security';

export const hsmGroupModalBreadcrumbTitle = `${prefix}.hsmGroupModalBreadcrumbTitle`;
export const thalesNetHsmModalBreadcrumbTitle = `${prefix}.thalesNetHsmModalBreadcrumbTitle`;
export const safenetLunaServerModalBreadcrumbTitle = `${prefix}.safenetLunaServerModalBreadcrumbTitle`;

export const ENGLISH = {
    [hsmGroupModalBreadcrumbTitle]: 'HSM Group',
    [thalesNetHsmModalBreadcrumbTitle]: 'Thales netHSM',
    [safenetLunaServerModalBreadcrumbTitle]: 'Thales Luna HSM Server',
};
